var Icon, m;

m = require('mithril');

Icon = require('./Icon');

module.exports = {
  view: function(ctrl, args) {
    var items;
    items = args.items;
    return m('ul.Breadcrumbs', items.map(function(item) {
      var attrs;
      attrs = {};
      if (item.onclick != null) {
        attrs["class"] = 'Breadcrumbs__content--link';
      }
      if (item.onclick != null) {
        attrs.onclick = item.onclick;
      }
      if (item.title != null) {
        attrs.title = item.title;
      }
      return m('li.Breadcrumbs__item', m('span.Breadcrumbs__content', attrs, [item.icon != null ? Icon[item.icon]() : void 0, item.icon != null ? ' ' : void 0, item.content]));
    }));
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9CcmVhZGNydW1icy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvYXBwL3NyYy91aS9jb21wb25lbnRzL0JyZWFkY3J1bWJzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLENBQUEsR0FBSSxPQUFBLENBQVEsU0FBUjs7QUFFSixJQUFBLEdBQU8sT0FBQSxDQUFRLFFBQVI7O0FBRVAsTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDaEIsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLElBQVA7QUFDTCxRQUFBO0lBQUEsS0FBQSxHQUFRLElBQUksQ0FBQztXQUNiLENBQUEsQ0FBRSxnQkFBRixFQUFvQixLQUFLLENBQUMsR0FBTixDQUFVLFNBQUMsSUFBRDtBQUM3QixVQUFBO01BQUEsS0FBQSxHQUFRO01BQ1IsSUFBNkMsb0JBQTdDO1FBQUEsS0FBSyxFQUFDLEtBQUQsRUFBTCxHQUFhLDZCQUFiOztNQUNBLElBQWdDLG9CQUFoQztRQUFBLEtBQUssQ0FBQyxPQUFOLEdBQWdCLElBQUksQ0FBQyxRQUFyQjs7TUFDQSxJQUE0QixrQkFBNUI7UUFBQSxLQUFLLENBQUMsS0FBTixHQUFjLElBQUksQ0FBQyxNQUFuQjs7YUFDQSxDQUFBLENBQUUsc0JBQUYsRUFDQyxDQUFBLENBQUUsMkJBQUYsRUFBK0IsS0FBL0IsRUFBc0MsQ0FDaEIsaUJBQXJCLEdBQUEsSUFBSyxDQUFBLElBQUksQ0FBQyxJQUFMLENBQUwsQ0FBQSxDQUFBLEdBQUEsTUFEcUMsRUFFOUIsaUJBQVAsR0FBQSxHQUFBLEdBQUEsTUFGcUMsRUFHckMsSUFBSSxDQUFDLE9BSGdDLENBQXRDLENBREQ7SUFMNkIsQ0FBVixDQUFwQjtFQUZLLENBRFUifQ==
